import { Icon, IconProps } from './Icon';

interface CalendarIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const CalendarIcon = ({ color = '#5E6A81', gradient, ...props }: CalendarIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M18.6663 2.33301V6.99967"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.33333 2.33301V6.99967"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.5 10.5003H24.5"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1667 4.66699H5.83333C4.54417 4.66699 3.5 5.71116 3.5 7.00033V22.167C3.5 23.4562 4.54417 24.5003 5.83333 24.5003H22.1667C23.4558 24.5003 24.5 23.4562 24.5 22.167V7.00033C24.5 5.71116 23.4558 4.66699 22.1667 4.66699Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.0148 14.8503C13.8538 14.8503 13.7231 14.9809 13.7243 15.1419C13.7243 15.3029 13.855 15.4336 14.016 15.4336C14.177 15.4336 14.3076 15.3029 14.3076 15.1419C14.3076 14.9809 14.177 14.8503 14.0148 14.8503"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M19.8488 14.8503C19.6878 14.8503 19.5571 14.9809 19.5583 15.1419C19.5583 15.3029 19.6889 15.4336 19.8499 15.4336C20.0109 15.4336 20.1416 15.3029 20.1416 15.1419C20.1416 14.9809 20.0109 14.8503 19.8488 14.8503"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.18178 19.5173C8.02078 19.5173 7.89011 19.6479 7.89128 19.8089C7.89128 19.9699 8.02195 20.1006 8.18295 20.1006C8.34395 20.1006 8.47461 19.9699 8.47461 19.8089C8.47461 19.6479 8.34395 19.5173 8.18178 19.5173"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.0148 19.5173C13.8538 19.5173 13.7231 19.6479 13.7243 19.8089C13.7243 19.9699 13.855 20.1006 14.016 20.1006C14.177 20.1006 14.3076 19.9699 14.3076 19.8089C14.3076 19.6479 14.177 19.5173 14.0148 19.5173"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
